import React from "react";
import {
  View,
  ScrollView,
  KeyboardAvoidingView,
  Platform,
  StyleSheet,
  Text,
} from "react-native";

import { isAndroid, navigate } from "../../../../helpers/utils";
import Header from "../../common/header/index";
import appStyles from "../../../appStyles";
import AppTheme from "../../AppTheme";
import IntegrationIcons from "../../common/icons/integrations/index";
import appPages from "../../../../appPages";
import ManaButton from "../../common/ManaButton";

export default class IntegrationsMappingDone extends React.Component {
  constructor(props) {
    super(props);
    this.controller = props.controller;

    this.state = {
      isMappingDone: props.isMappingDone, // no more elements to map
    };
  }

  goBack = () => {
    this.controller.goBack();
  };

  goTo = (page) => {
    this.controller.navigate(page);
  };

  render() {
    const { isMappingDone } = this.state;

    const pageTitle = isMappingDone 
      ? "You've given us great context!"
      : "Thanks for the context!";

    return (
      <View style={[appStyles.container, { backgroundColor: "#FFF" }]}>
        <KeyboardAvoidingView
          style={appStyles.kbViewNoFooter}
          behavior="position"
          keyboardVerticalOffset={isAndroid ? 30 : 0}
        >
          <Header title="That’s it!" goBack={this.goBack} />

          <ScrollView
            style={[appStyles.scrollView, styles.scrollView]}
            contentContainerStyle={styles.scrollViewContent}
          >
            <Text style={styles.title}>{pageTitle}</Text>

            <View
              style={{
                alignItems: "center",
                marginBottom: 42,
              }}
            >
              <IntegrationIcons.MappingsDoneBigIcon />
            </View>

            <Text style={styles.description}>
              We’re hard at work on the best insights into how you can spend
              time better.
            </Text>

            {isMappingDone ? (
              <View style={appStyles.horizontalButtons}>
                <ManaButton
                  onPress={() => this.goTo(appPages.homePage)}
                  style={[
                    appStyles.bottomButtonTwin,
                    appStyles.firstTwinButton,
                  ]}
                  styleText={appStyles.bottomButtonTwinText}
                  text="Done"
                />
                <ManaButton
                  isMainButton
                  onPress={() => this.goTo(appPages.integrationsV2)}
                  style={[appStyles.bottomButtonTwin]}
                  styleText={appStyles.bottomButtonTwinText}
                  text="Connect more integrations"
                />
              </View>
            ) : (
              <View style={appStyles.horizontalButtons}>
                <ManaButton
                  onPress={props.matchMore}
                  style={[
                    appStyles.bottomButtonTwin,
                    appStyles.firstTwinButton,
                  ]}
                  styleText={appStyles.bottomButtonTwinText}
                  text="Match more Elements"
                />

                <ManaButton
                  isMainButton
                  onPress={() => this.goTo(appPages.homePage)}
                  style={appStyles.bottomButtonTwin}
                  styleText={appStyles.bottomButtonTwinText}
                  text="Done"
                />
              </View>
            )}
          </ScrollView>
        </KeyboardAvoidingView>
      </View>
    );
  }
}

const styles = StyleSheet.create({
  scrollViewContent: {
    paddingTop: 104,
  },
  title: {
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-SemiBold",
    }),
    fontWeight: "600",
    fontSize: 20,
    lineHeight: 30,
    letterSpacing: 1,
    color: AppTheme.DEFAULT_COLOR,
    textAlign: "center",
    marginBottom: 31,
  },
  description: {
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-SemiBold",
    }),
    fontWeight: "600",
    fontSize: 14,
    lineHeight: 17,
    letterSpacing: 0.175,
    color: AppTheme.almostBlack,
    textAlign: "center",
    marginBottom: 42,
  },
});
